<ngx-spinner bdColor="rgba(9, 13, 22, 0.9)" [fullScreen]="true">
  <!-- Alternative Premium Option: The Golden Vault Orbit -->
  <div
    class="flex flex-col items-center justify-center space-y-6 select-none font-sans"
  >
    <div class="relative w-16 h-16 flex items-center justify-center">
      <!-- Outer Orbit Ring -->
      <div
        class="absolute inset-0 rounded-full border-2 border-slate-800"
      ></div>

      <!-- Spinning Golden Track (Segmented) -->
      <div
        class="absolute inset-0 rounded-full border-2 border-t-[#ffbe3b] border-r-transparent border-b-[#ffbe3b] border-l-transparent animate-vault-spin"
      ></div>

      <!-- Shifting Diamond Core -->
      <div
        class="w-4 h-4 bg-[#ffbe3b] rotate-45 rounded-[2px] shadow-[0_0_15px_rgba(255,190,59,0.8)] animate-diamond-morph"
      ></div>
    </div>

    <!-- Typography Status -->
    <div class="text-center">
      <h3
        class="text-[11px] font-black tracking-[0.2em] uppercase text-white italic"
      >
        Loading <span class="text-[#ffbe3b]">Assets</span>
      </h3>
      <div
        class="w-12 h-[1px] bg-gradient-to-r from-transparent via-[#ffbe3b]/50 to-transparent mx-auto my-1.5"
      ></div>
      <p
        class="text-[8px] text-slate-500 uppercase tracking-widest font-bold animate-pulse"
      >
        Please wait a moment
      </p>
    </div>
  </div>
</ngx-spinner>
<ngx-spinner bdColor="rgba(9, 13, 22, 0.9)" [fullScreen]="true">
  <!-- Alternative Premium Option: The Golden Vault Orbit -->
  <div
    class="flex flex-col items-center justify-center space-y-6 select-none font-sans"
  >
    <div class="relative w-16 h-16 flex items-center justify-center">
      <!-- Outer Orbit Ring -->
      <div
        class="absolute inset-0 rounded-full border-2 border-slate-800"
      ></div>

      <!-- Spinning Golden Track (Segmented) -->
      <div
        class="absolute inset-0 rounded-full border-2 border-t-[#ffbe3b] border-r-transparent border-b-[#ffbe3b] border-l-transparent animate-vault-spin"
      ></div>

      <!-- Shifting Diamond Core -->
      <div
        class="w-4 h-4 bg-[#ffbe3b] rotate-45 rounded-[2px] shadow-[0_0_15px_rgba(255,190,59,0.8)] animate-diamond-morph"
      ></div>
    </div>

    <!-- Typography Status -->
    <div class="text-center">
      <h3
        class="text-[11px] font-black tracking-[0.2em] uppercase text-white italic"
      >
        Loading <span class="text-[#ffbe3b]">Assets</span>
      </h3>
      <div
        class="w-12 h-[1px] bg-gradient-to-r from-transparent via-[#ffbe3b]/50 to-transparent mx-auto my-1.5"
      ></div>
      <p
        class="text-[8px] text-slate-500 uppercase tracking-widest font-bold animate-pulse"
      >
        Please wait a moment
      </p>
    </div>
  </div>
</ngx-spinner>
